import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_button = _resolveComponent("the-button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_button_dropdown = _resolveComponent("button-dropdown")!

  return (_openBlock(), _createBlock(_component_button_dropdown, {
    icon: "fas fa-ellipsis-h",
    strategy: "fixed"
  }, {
    default: _withCtx(() => [
      (_ctx.canUpdate)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 0,
            target: "_blank",
            class: "link",
            to: `/new-dispatcher/couriers/${_ctx.courier.id}?edit=1`
          }, {
            default: _withCtx(() => [
              _createVNode(_component_the_button, {
                class: "small primary mr-2",
                onClick: _ctx.emitUpdate
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Редактировать ")
                ]),
                _: 1
              }, 8, ["onClick"])
            ]),
            _: 1
          }, 8, ["to"]))
        : _createCommentVNode("", true),
      _createVNode(_component_the_button, {
        class: _normalizeClass(["small primary", { text: _ctx.state.is_user_session_loading }]),
        loading: _ctx.state.is_user_session_loading,
        onClick: _ctx.createUserSession
      }, {
        default: _withCtx(() => [
          _createTextVNode(" Войти под курьером ")
        ]),
        _: 1
      }, 8, ["class", "loading", "onClick"]),
      (_ctx.havePermissions(['dispatcher.courier-update', 'all-root-permission']))
        ? (_openBlock(), _createBlock(_component_the_button, {
            key: 1,
            class: "small primary",
            onClick: _ctx.emitSetPhone
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Сменить номер ")
            ]),
            _: 1
          }, 8, ["onClick"]))
        : _createCommentVNode("", true),
      _createVNode(_component_the_button, {
        class: "small primary",
        onClick: _ctx.emitQr
      }, {
        default: _withCtx(() => [
          _createTextVNode(" Показать QR ")
        ]),
        _: 1
      }, 8, ["onClick"]),
      (_ctx.havePermissions(['gateway-get-code-for-auth', 'all-root-permission']))
        ? (_openBlock(), _createBlock(_component_the_button, {
            key: 2,
            class: _normalizeClass(["small primary", { text: _ctx.state.is_code_loading }]),
            loading: _ctx.state.is_code_loading,
            disabled: _ctx.state.is_code_loading,
            onClick: _ctx.getCode
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Получить код курьера ")
            ]),
            _: 1
          }, 8, ["class", "loading", "disabled", "onClick"]))
        : _createCommentVNode("", true),
      (
                _ctx.courier.routingEnabled &&
                _ctx.havePermissions(['dispatcher.courier-app.routing.store', 'all-root-permission'])
            )
        ? (_openBlock(), _createBlock(_component_the_button, {
            key: 3,
            class: _normalizeClass(["small primary", { text: _ctx.state.is_create_route_loading }]),
            loading: _ctx.state.is_create_route_loading,
            onClick: _ctx.createRoute
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Построить маршрут ")
            ]),
            _: 1
          }, 8, ["class", "loading", "onClick"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}